import loadStorageData from 'shared/Storage';

import {CALL_API} from 'middleware/api';

import {LOAD_STORAGE} from '../Storage';

export const SIGNIN = 'SIGNIN';
export const SUCCESS_SIGNIN = 'SUCCESS_SIGNIN';
export const FAILURE_SIGNIN = 'FAILURE_SIGNIN';

function fetchSignin(data) {
    return {
        type: SIGNIN,
        [CALL_API]: {
            endpoint: '/api/sign/in',
            method: 'post',
            types: [
                [SUCCESS_SIGNIN, loadStorageData, LOAD_STORAGE],
                FAILURE_SIGNIN
            ],
            credentials: true,
            data
        }
    };
}

export function signin(data) {
    return (dispatch) => {
        dispatch(fetchSignin(data));
    };
}



// WEBPACK FOOTER //
// ./js/actions/auth/SigninAction.js